export default "__VITE_ASSET__Q8MLCTz2__"